export default __webpack_public_path__ + "static/media/walkThrough006.32a7d214.png";